// Altera o status de um pedido
(function () {
  'use strict';

  // Variáveis
  const $btnCarrinho = $('.btn-cart-aband');
  const $modalCarrinho = $('#modal-carrinho');
  const $tabelaProdsCarrinho = $('#mca_prods');
  const $formCarrinho = $('#form-carrinho');

  // Evento ao enviar o formulário para o cliente
  $formCarrinho.on('submit', function (e) {
    e.preventDefault();
    const dados = $formCarrinho.serialize();
    const url = $formCarrinho.attr('action');
    showLoader();
    $.post(
      url,
      dados,
      function (result) {
        console.log(result);
        hideLoader();
        // Sucesso
        if (result.status == 'success') {
          Toast.fire({
            type: 'success',
            title: result.mensagem,
          });
        }
        // Erro
        else {
          Toast.fire({
            type: 'error',
            title: result.mensagem,
          });
        }
      },
      'json',
    );
  });

  // Evento de click ao clicar no botão para exibir o carrinho
  $btnCarrinho.on('click', function (ev) {
    ev.preventDefault();
    showModalCarrinho($(this));
  });

  // Evento de click para enviar carrinho por e-mail
  $('.mca-send-mail').on('click', function (ev) {
    ev.preventDefault();
    showConfirm({
      type: 'default',
      title: 'Enviar e-mail',
      text: 'Deseja enviar este carrinho por e-mail?',
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $formCarrinho.submit();
      },
    });
  });

  // Exibe o modal para alteração de status
  function showModalCarrinho($btn) {
    console.log($btn.data('infos'));
    const infos = $btn.data('infos');
    const produtos = infos.products;
    $('#mca_nome').val(infos.customer_name);
    $('#mca_email').val(infos.customer_email);
    $('#mca_telefone').val(infos.customer_cell);
    $('#mca_data').val(infos.data_view);
    //CKEDITOR.instances.mensagem.setData(infos.msg_email);
    $('#form-carrinho input[name="cart_id"]').val(infos.id);
    $('#cart_url').val(infos.cart_url);
    $modalCarrinho.find('.btn-clipboard-modal').data('clipboard-text', infos.cart_url);
    $('#mca-whats-link').hide();
    if (infos.customer_cell) {
      $('#mca-whats-link').attr('href', infos.link_wpp);
      $('#mca-whats-link').show();
    }
    $tabelaProdsCarrinho.find('tbody').html('');
    $('#cart_products').val('');
    if (produtos && produtos.length > 0) {
      $('#cart_products').val(JSON.stringify(produtos));
      produtos.forEach((prod) => {
        const variante =
          prod.variant_title && prod.variant_title != prod.title ? `<p><small>${prod.variant_title}</small></p>` : '';
        $tabelaProdsCarrinho.find('tbody').append(`
        <tr>
          <td>
            <div class="d-flex align-items-center" style="flex-wrap: wrap;">
              <img src="${prod.image}" class="img-fluid rounded mr-2" width="50px">
              <div class="pedido-table-infos">
                <p><b>${prod.title}</b></a></p>
                ${variante}
              </div>
            </div>
          </td>
          <td class="text-md-center" data-label="Quantidade:">${prod.product_qtdy}</td>
          <td class="d-none d-md-table-cell">x</td>
          <td data-label="Valor:">R$ ${prod.sale_price}</td>
          <td class="text-md-right" data-label="Total:">R$ ${formatMoneyBR(prod.total)}</td>
        </tr>`);
      });
      $tabelaProdsCarrinho.find('tbody').append(`
        <tr>
          <td colspan="4" class="text-right"><b style="font-size: 1.15em;">Total do carrinho:<b></td>
          <td class="text-right"><b style="font-size: 1.15em;">R$ ${formatMoneyBR(infos.total)}<b></td>
        </tr>`);
    } else {
      $tabelaProdsCarrinho.find('tbody').append(`
      <tr>
        <td colspan="5" class="text-center">Nenhum produto adicionado ao carrinho.</td>
      </tr>`);
    }
    $modalCarrinho.find('#modal-carrinho-label').text('Carrinho Abandonado #' + infos['id']);
    $modalCarrinho.modal('show');
  }
})();

// Filtro por produto
(function () {
  'use strict';
  $('#filtro_carrinho_produto').on('change', function () {
    let prodFiltro = $(this).val();
    if (prodFiltro == 'all') {
      prodFiltro = '';
    }
    $('#filtro').find('input[name="produto"]').val(prodFiltro);
    $('#filtro').submit();
  });
})();
